'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('cb.util.cbPrivate', []).directive('cbPrivate', cbPrivate);

exports.default = _module;


function cbPrivate() {
    return {
        restrict: 'A',
        link: function link(scope, element, attr) {
            // check value of attribute, "false" is added when using ng-attr-cb-private=""
            if (attr.cbPrivate !== 'false' || attr.dataCbPrivate !== 'false') {
                // masking elements in hotjar: http://docs.hotjar.com/docs/masking-elements-in-recordings-and-heatmaps
                element.attr('data-hj-masked', '');
            }
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/util/cb-private.directive.js
// module id = 828
// module chunks = 0